module.exports = __webpack_public_path__ + "img/react.56c6cb9a.png";